import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-cart',
  templateUrl: './my-cart.component.html',
  styleUrl: './my-cart.component.scss',
})
export class MyCartComponent {
  @Output() buttonClicked: EventEmitter<any> = new EventEmitter<void>();
  @Output('cartClick') cartClick: EventEmitter<any> = new EventEmitter<void>();
  @Input() product: any;

@Output() colorSelected = new EventEmitter<string | null>();


  mycartImageUrl = environment.ImageBaseUrl;
  productImageTemp = 'http://localhost:5000/uploads/temp/';
  cartItems: any;
  variantData: any;
  variantImages: any;
    attributeSize: any;
  displayPrice: any;

selectedColor: string | null = null;
  constructor(
    private api: ApiServiceService,
    private toastr: ToastrService,
    private Loader: LoaderService,
    private router: Router
  ) {}

  // ngOnInit() {
  //   this.attributeSize = this.product.attributeSize || null;

  //   console.log('this.attributes my cart-->', this.attributeSize)
  //   const variantId = this.product.variantData;
  //   const matchedVariant = this.product.product_id.variants?.find(
  //     (v: any) => v._id === variantId
  //   );
  //   this.variantData = matchedVariant;
  //   if (matchedVariant && matchedVariant.images?.length > 0) {
  //     this.variantImages = matchedVariant.images[0];
  //   }
  //   console.log('this variantData', this.variantImages);

    
  // }

ngOnInit() {
  // ---------- VARIANT ----------
  this.variantData = null;
  

  if (this.product?.variantData) {
    // Case 1: already object
    if (typeof this.product.variantData === 'object') {
      this.variantData = this.product.variantData;
    }

    // Case 2: JSON string
    else if (typeof this.product.variantData === 'string') {
      try {
        this.variantData = JSON.parse(this.product.variantData);
      } catch {
        // Case 3: variantId string → find from product variants
        this.variantData =
          this.product.product_id?.variants?.find(
            (v: any) => v._id === this.product.variantData
          ) || null;
      }
    }
  }

  // this.varinatColor = params['variantColor'] ;

  // ---------- VARIANT IMAGE ----------
  this.variantImages =
    this.variantData?.images?.length > 0
      ? this.variantData.images[0]
      : null;

  // ---------- SIZE ----------
  this.attributeSize = null;
  if (this.product?.attributeSize) {
    if (typeof this.product.attributeSize === 'object') {
      this.attributeSize = this.product.attributeSize;
    } else {
      try {
        this.attributeSize = JSON.parse(this.product.attributeSize);
      } catch {
        this.attributeSize = null;
      }
    }
  }

this.selectedColor = this.product?.variantColor || null;
   this.colorSelected.emit(this.selectedColor); // 🔥 send to parent

  // ---------- FINAL PRICE ----------
  this.displayPrice =
    this.attributeSize?.price ||
    this.variantData?.sellingPrice ||
    this.product.product_id?.priceInventoryShippingInfo?.sellingPrice;


  
}






  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  removeQty(id: any, qty: any, product: any) {
    if (qty > 1) {
      const quantity = qty - 1;
      product.quantity = quantity; // Optimistically update the product quantity
      this.updateCart(id, quantity);
      this.cartClick.emit();
    }
  }

  // addQty(id: any, qty: any, product: any) {
  //   const quantity = qty + 1;
  //   product.quantity = quantity; // Optimistically update the product quantity
  //   this.updateCart(id, quantity);
  //   this.cartClick.emit();
  // }

// addQty(id: any, qty: any, product: any) {
//   // Ensure we have stock info (e.g., product.inStock, product.stock, etc.)
//   const maxStock = product?.product_id?.priceInventoryShippingInfo.stock ; // Adjust field name as per your data
//   const newQuantity = qty + 1;

//   if (newQuantity > maxStock) {
//     // Show toastr: Out of stock
//     this.toastr.warning(`Only ${maxStock} item(s) available in stock.`, 'Out of Stock');
//     return; // Do not update
//   }

//   // Update quantity in UI and backend
//   product.quantity = newQuantity;
//   this.updateCart(id, newQuantity);
//   this.cartClick.emit();
//   this.emitItemTotal();   // ✅ send updated amount
// }

addQty(id: any, qty: any, product: any) {
  let maxStock = 0;

  /* 1️⃣ SIZE stock (highest priority) */
  if (
    product?.attributeSize &&
    typeof product.attributeSize === 'object' &&
    product.attributeSize.stock != null
  ) {
    maxStock = Number(product.attributeSize.stock);
  }

  /* 2️⃣ VARIANT stock */
  else if (product?.variantData) {
    let variant: any = null;

    // Variant already object
    if (typeof product.variantData === 'object') {
      variant = product.variantData;
    }
    // Variant as JSON string
    else if (
      typeof product.variantData === 'string' &&
      product.variantData.startsWith('{')
    ) {
      try {
        variant = JSON.parse(product.variantData);
      } catch {}
    }
    // Variant as ID
    else {
      variant = product?.product_id?.variants?.find(
        (v: any) => v._id === product.variantData
      );
    }

    if (variant?.stock != null) {
      maxStock = Number(variant.stock);
    }
  }

  /* 3️⃣ BASE product stock (fallback) */
  else {
    maxStock = Number(
      product?.product_id?.priceInventoryShippingInfo?.stock || 0
    );
  }

  const newQuantity = qty + 1;

  if (newQuantity > maxStock) {
    this.toastr.warning(
      `Only ${maxStock} item(s) available in stock.`,
      'Out of Stock'
    );
    return;
  }

  // ✅ Update quantity
  product.quantity = newQuantity;
  this.updateCart(id, newQuantity);
  this.cartClick.emit();
}


  updateCart(productId: string, quantity: number) {
    const userId = this.getCurrentUserId(); // Replace with actual user ID fetch logic

    this.cartClick.emit();
    this.api.updateCart(productId, quantity, userId).subscribe(
      (res: any) => {
        if (res.success) {
          this.toastr.success(res.message, '', {
            toastClass: 'ngx-toastr toast-custom toast-success', // Make sure the custom class is applied here
          });
        } else {
          this.toastr.error(res.message, '', {
            toastClass: 'ngx-toastr toast-custom toast-success', // Make sure the custom class is applied here
          });
        }
      },
      (error) => {
        console.error('Error updating cart:', error);
        this.toastr.error('Failed to update cart');
      }
    );
  }

  deleteCartItem(productId: string, qty: number) {
    const userId = this.getCurrentUserId(); // Replace with actual user ID fetch logic

    // Call the API to delete the item from the cart
    this.api.deleteCartItem(productId, userId).subscribe(
      (res: any) => {
        if (res.success) {
          this.cartClick.emit();
          // Optionally remove the item from the local cart for real-time update
          this.cartItems = this.cartItems.filter(
            (item: any) => item.product_id._id !== productId
          );
          // window.dispatchEvent(
          //   new CustomEvent('cartUpdatedDecreament', { detail: 1 })
          // );
        } else {
          this.cartClick.emit();
          this.toastr.success(res.message, '', {
            toastClass: 'ngx-toastr toast-custom toast-success', // Make sure the custom class is applied here
          });
          window.dispatchEvent(
            new CustomEvent('cartUpdatedDecreament', { detail: 1 })
          );
        }
      },
      (error) => {
        console.error('Error deleting cart item:', error);
        this.toastr.error('Failed to delete cart item');
      }
    );
  }



  getProductById(id: any) {
    this.router.navigate(['product-details', id]);
  }
}
